export default {
  beforeRouteUpdate(to, from, next) {
    // Go to next route
    // Next must be called before init
    try {
      next()
    } catch (e) {
      console.warn(e.message)
    }
    // If not same route and not same query request data from laravel
    if (to.fullPath !== from.fullPath) {
      this.init()
    }
  },
}
